export default "__VITE_ASSET__C3Mp9cHO__"